import React, { useEffect, useState } from "react";
import * as API from "../helpers/api";
import config from "../config";
import Loading from "react-loader-spinner";
import { useLang } from "../helpers/language";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import "../assets/css/pages/contact-us.scss";
import { Dictionary } from "../assets/js/contexts";
import SubmitCareerForm from "../components/forms/SubmitCareerForm";
import ReservationForm from "../components/forms/ReservationForm";
import OtherForm from "../components/forms/OtherForm";
import PartnersForm from "../components/forms/PartnersForm";
import { useFormik } from "formik";
import * as yup from "yup";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";
import {
  generateCareerFormEmailTemplate,
  generateOtherFormEmailTemplate,
  generatePartnersFormEmailTemplate,
  generateReservationFormEmailTemplate,
} from "../components/forms/emailTemplates";

const ContactUs = ({ dictionary }) => {
  const { lang } = useLang();
  const [isBusy, setBusy] = useState(true);
  const [brewery, setBrewery] = useState(undefined);
  const [brewpub, setBrewpub] = useState(undefined);
  const [contacts, setContacts] = useState(undefined);
  let url = new URL(window.location.href);
  let restParams = {
    page: url.searchParams.get("contact"),
  };
  const [tab1, settab1] = useState(false);
  const [tab2, settab2] = useState(false);
  const [tab3, settab3] = useState(false);
  const [tab4, settab4] = useState(true);
  const [sent, setsent] = useState(false);
  const showLoader = () => {
    setsent(true);
  };
  const hideLoader = () => {
    setsent(false);
  };

  const emailTitles = {
    info: {
      en: "Info:",
      ru: "Сотрудничество:",
      hy: "Ընդհանուր՝",
    },
    marketing: {
      en: "Marketing:",
      ru: "Маркетинг:",
      hy: "Մարքեթինգ՝",
    },
    sales: {
      en: "Sales:",
      ru: "Продажи:",
      hy: "Վաճառք՝",
    },
  };

  const toggleTab = (e) => {
    if (e.target.classList.contains("tab1")) {
      settab1(true);
      settab2(false);
      settab3(false);
      settab4(false);
    }
    if (e.target.classList.contains("tab2")) {
      settab1(false);
      settab2(true);
      settab3(false);
      settab4(false);
    }
    if (e.target.classList.contains("tab3")) {
      settab1(false);
      settab2(false);
      settab3(true);
      settab4(false);
    }
    if (e.target.classList.contains("tab4")) {
      settab1(false);
      settab2(false);
      settab3(false);
      settab4(true);
    }
  };
  const tabTitles = {
    tab1: {
      title: {
        en: "Partnership",
        ru: "Сотрудничество",
        hy: "Համագործակցություն",
      },
    },
    tab2: {
      title: {
        en: "Careers",
        ru: "Работа",
        hy: "Աշխատանք",
      },
    },
    tab3: {
      title: {
        en: "Tour to brewery",
        ru: "Тур по пивоварне",
        hy: "Շրջայց գործարան",
      },
    },
    tab4: {
      title: {
        en: "Other",
        ru: "Другое ",
        hy: "Այլ",
      },
    },
  };
  const contactLabels = {
    title: {
      en: "Subject",
      ru: "Название",
      hy: "Վերնագիր",
    },
    selectCategoryTitle: {
      en: "Choose category",
      ru: "Выберите категорию",
      hy: "Ընտրեք կատեգորիան",
    },
    selectCategory: [
      {
        title: {
          en: "Category 1",
          ru: "Категория 1",
          hy: "Կատեգորիա 1",
        },
      },
      {
        title: {
          en: "Category 2",
          ru: "Категория 2",
          hy: "Կատեգորիա թ",
        },
      },
      {
        title: {
          en: "Category 3",
          ru: "Категория 3",
          hy: "Կատեգորիա 3",
        },
      },
    ],
    selectLanguageTitle: {
      en: "Choose Language",
      ru: "Выберите язык",
      hy: "Ընտրեք լեզուն",
    },
    selectLanguage: [
      {
        title: {
          en: "English",
          ru: "Английский",
          hy: "Անգլերեն",
        },
      },
      {
        title: {
          en: "Russian",
          ru: "Русский",
          hy: "Ռուսերեն",
        },
      },
      {
        title: {
          en: "Armenian",
          ru: "Армянский",
          hy: "Հայերեն",
        },
      },
    ],
    email: {
      en: "Email",
      ru: "Эл.адресс",
      hy: "Էլ․փոստ",
    },
    phone: {
      en: "Phone",
      ru: "Номер",
      hy: "Համար",
    },
    name: {
      en: "Firstname Lastname",
      ru: "Имя Фамилия",
      hy: "Անուն Ազգանուն",
    },
    message: {
      en: "Message",
      ru: "Сообщение",
      hy: "Նամակ",
    },
    button: {
      en: "Send",
      ru: "Отправить",
      hy: "ՈՒղարկել",
    },
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      let rawBrewery = await API.get(config.api.contactBrewery);
      setBrewery(rawBrewery[0]);

      let rawBrewpub = await API.get(config.api.contactBrewpub);
      setBrewpub(rawBrewpub[0]);

      let rawContacts = await API.get(config.api.contactus);
      setContacts(rawContacts[0]);
      if (restParams.page === "career") {
        settab2(true);
        settab4(false);
      }
      setBusy(false);
    })();
    // eslint-disable-next-line
  }, [isBusy]);

  const partnersValidationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    subject: yup.string().required("Subject is required"),
    description: yup.string().required("Message is required"),
  });
  const careerValidationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    subject: yup.string().required("Subject is required"),
    description: yup.string().required("Message is required"),
  });
  const reservationValidationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: yup.number().required("Phone is required"),
    subject: yup.string().required("Subject is required"),
    description: yup.string().required("Message is required"),
  });
  const otherValidationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .email("Invalid email address")
      .required("Email is required"),
    subject: yup.string().required("Subject is required"),
    description: yup.string().required("Message is required"),
  });
  const initialValues = {
    name: "",
    email: "",
    subject: "",
    description: "",
    category: "",
    language: "",
  };
  const formik = useFormik({
    initialValues,
    validationSchema:
      (tab1 && partnersValidationSchema) ||
      (tab2 && careerValidationSchema) ||
      (tab3 && reservationValidationSchema) ||
      (tab4 && otherValidationSchema),
    onSubmit: (values) => {
      sendEmail(values);
    },
  });
  const sendEmail = ({
    name,
    email,
    subject,
    description,
    phone,
    category,
    language,
  }) => {
    showLoader();
    const partnersFormTemplate = generatePartnersFormEmailTemplate({
      name,
      email,
      subject,
      description,
      message_type: "Partners Form",
    });
    const reservationFormTemplate = generateReservationFormEmailTemplate({
      name,
      email,
      phone,
      language,
      subject,
      description,
      message_type: "Reservation Form",
    });
    const careerFormTemplate = generateCareerFormEmailTemplate({
      name,
      category,
      subject,
      description,
      message_type: "Career Form",
    });
    const otherFormTemplate = generateOtherFormEmailTemplate({
      name,
      email,
      subject,
      description,
      message_type: "Other Form",
    });
    emailjs
      .send(
        "service_c3qp3jo",
        "template_gehqqeq",
        (tab1 && partnersFormTemplate) ||
          (tab2 && careerFormTemplate) ||
          (tab3 && reservationFormTemplate) ||
          (tab4 && otherFormTemplate),
        "0C5YYTfrdIuARCrqx"
      )
      .then(
        (result) => {
          Swal.fire(config.swal.success[lang]);
          hideLoader();
        },
        (error) => {
          Swal(config.swal.error[lang]);
        }
      );
  };
  if (!isBusy && contacts && brewpub && brewery)
    return (
      <Dictionary.Provider value={dictionary}>
        <div id="contact-us">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9" style={{ marginBottom: 60 }}>
                <h1>{contacts?.title[lang] ? contacts.title[lang] : ""}</h1>
                <div className="text-center" style={{ marginBottom: 38 }}>
                  {parse(contacts?.desc[lang] ? contacts.desc[lang] : "")}{" "}
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="card black h-100">
                      <h2>
                        {brewpub?.title[lang] ? brewpub?.title[lang] : ""}
                      </h2>
                      <p>
                        {" "}
                        {brewpub?.address[lang] ? brewpub?.address[lang] : ""}
                        <br /> {brewpub.phone ? brewpub.phone : ""}
                        <br />
                        <br />
                        {emailTitles.info[lang]}{" "}
                        {brewpub.email && (
                          <a
                            style={{
                              color: "white",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewpub.email}`}
                          >
                            {brewpub.email}
                          </a>
                        )}
                        <br />
                        <br />
                        {emailTitles.marketing[lang]}{" "}
                        {brewpub.marketingEmail && (
                          <a
                            style={{
                              color: "white",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewpub.marketingEmail}`}
                          >
                            {brewpub.marketingEmail}
                          </a>
                        )}
                        <br />
                        <br />
                        {emailTitles.sales[lang]}{" "}
                        {brewpub.salesEmail && (
                          <a
                            style={{
                              color: "white",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewpub.salesEmail}`}
                          >
                            {brewpub.salesEmail}
                          </a>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="card primary h-100">
                      <h2>
                        {brewery?.title[lang] ? brewery?.title[lang] : ""}
                      </h2>
                      <p>
                        {" "}
                        {brewery?.address[lang] ? brewery?.address[lang] : ""}
                        <br /> {brewery.phone ? brewery.phone : ""}
                        <br />
                        <br />
                        {emailTitles.info[lang]}{" "}
                        {brewery.email && (
                          <a
                            style={{
                              color: "black",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewery.email}`}
                          >
                            {brewery.email}
                          </a>
                        )}
                        <br />
                        <br />
                        {emailTitles.marketing[lang]}{" "}
                        {brewery.marketingEmail && (
                          <a
                            style={{
                              color: "black",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewery.marketingEmail}`}
                          >
                            {brewery.marketingEmail}
                          </a>
                        )}
                        <br />
                        <br />
                        {emailTitles.sales[lang]}{" "}
                        {brewery.salesEmail && (
                          <a
                            style={{
                              color: "black",
                              textDecoration: "underline",
                            }}
                            href={`mailto:${brewery.salesEmail}`}
                          >
                            {brewery.salesEmail}
                          </a>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9">
                <div className="tabs justify-content-between row">
                  <div className="col-lg-3 col-md-6 col-12 text-center">
                    <Link to={`/contact-us?lang=${lang}&contact=partnership`}>
                      <button
                        aria-label="tab1"
                        className={`tab tab1 ${tab1 ? "active" : ""}`}
                        onClick={toggleTab}
                      >
                        {tabTitles.tab1.title[lang]}
                      </button>
                    </Link>
                  </div>
                  <div className="col-lg-3 col-md-6 col-12 text-center">
                    <Link to={`/contact-us?lang=${lang}&contact=career`}>
                      <button
                        aria-label="tab2"
                        className={`tab tab2 ${tab2 ? "active" : ""}`}
                        onClick={toggleTab}
                      >
                        {tabTitles.tab2.title[lang]}{" "}
                      </button>
                    </Link>
                  </div>
                  <div className="col-lg-3 col-md-6 col-12 text-center">
                    <Link to={`/contact-us?lang=${lang}&contact=tour`}>
                      <button
                        aria-label="tab3"
                        className={`tab tab3 ${tab3 ? "active" : ""}`}
                        onClick={toggleTab}
                      >
                        {tabTitles.tab3.title[lang]}
                      </button>
                    </Link>
                  </div>
                  <div className="col-lg-3 col-md-6 col-12 text-center">
                    <Link to={`/contact-us?lang=${lang}&contact=other`}>
                      <button
                        aria-label="tab4"
                        className={`tab tab4 ${tab4 ? "active" : ""}`}
                        onClick={toggleTab}
                      >
                        {tabTitles.tab4.title[lang]}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-9 mt-5">
                <PartnersForm
                  dictionary={dictionary}
                  contactLabels={contactLabels}
                  tab={tab1}
                  formik={formik}
                  sent={sent}
                />
                <SubmitCareerForm
                  dictionary={dictionary}
                  contactLabels={contactLabels}
                  tab={tab2}
                  formik={formik}
                  sent={sent}
                />
                <ReservationForm
                  dictionary={dictionary}
                  contactLabels={contactLabels}
                  tab={tab3}
                  formik={formik}
                  sent={sent}
                />
                <OtherForm
                  dictionary={dictionary}
                  contactLabels={contactLabels}
                  tab={tab4}
                  formik={formik}
                  sent={sent}
                />
              </div>
            </div>
          </div>
        </div>
      </Dictionary.Provider>
    );
  else return <Loading type="Oval" color="#FFBE03" className="dms-loader" />;
};

export default ContactUs;
